import { GridCol, GridContainer } from '@bob/library'
import { Form } from '@websrc/App/Components/Form/Form'
import { mapForm } from '@websrc/DataMappers/mapSpot'
import { CSSpot_Settings } from '@websrc/Typings/ContentStack'
import React, { FC } from 'react'

import SpotContentDecoration from '../SpotContentDecoration/SpotContentDecoration'
import SpotDecoration from '../SpotDecoration/SpotDecoration'
import { spotForm } from './SpotForm.css'

export interface SpotFormProps {
  spot: ReturnType<typeof mapForm> & { settings: CSSpot_Settings }
}

export const SpotForm: FC<SpotFormProps> = ({ spot }) => {
  const {
    action_on_submit,
    description,
    headline,
    script,
    realTimeFormScript,
    submit_page_message,
    submit_redirect_url,
    tracking_enabled,
    settings,
    trackingId,
  } = spot

  return (
    <SpotDecoration spotSettings={settings}>
      <GridContainer className={spotForm._}>
        <GridCol>
          <SpotContentDecoration spotSettings={settings}>
            <Form
              action_on_submit={action_on_submit}
              description={description}
              headline={headline}
              realTimeFormScript={realTimeFormScript}
              script={script}
              submit_page_message={submit_page_message}
              submit_redirect_url={submit_redirect_url}
              tracking_enabled={tracking_enabled}
              trackingId={trackingId}
            />
          </SpotContentDecoration>
        </GridCol>
      </GridContainer>
    </SpotDecoration>
  )
}
